import React from "react";
import styled from "styled-components";
import { Card } from "../../../../designSystem/Card";
import { colors } from "../../../../designSystem/colors/color";
import { Flex } from "../../../../designSystem/compositeComponents/FlexHelpers";
import { iconName, Icon } from "../../../../designSystem/icons/Icons";


export function SurveyFactBox(props: { 
    icon:iconName,
    header1?:string,
    header2?:string,
    content:React.ReactNode,
}): JSX.Element {
    return (
        <Card variant="lightGray" noBorder>
            <Flex flexDirection="column" gap={4}>
                <div>
                    <Icon name={props.icon} color={colors.icon.active} />
                </div>
                {props.header1 && <FactBoxHeader1>{props.header1}</FactBoxHeader1>}
                {props.header2 && <FactBoxHeader2>{props.header2}</FactBoxHeader2>}
                <FactBoxContent>{props.content}</FactBoxContent>
            </Flex>
        </Card>
    );
}

const FactBoxHeader1 = styled.h3`
    margin: 0;
    font-size: 12px;
    font-weight: 400;
    color: ${colors.text.gray.normal};
    text-transform: uppercase;
`;

const FactBoxHeader2 = styled.h4`
    margin: 0;
    font-size: 16px;
    font-weight: 500;
`;

const FactBoxContent = styled.div`
    margin-top: 8px;
    font-size: 14px;
    color: ${colors.text.gray.normal};
`;